module.exports = __webpack_public_path__ + "static/img/NI.2b30b45c.png";